import { XCircle } from "lucide-react";
import {
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogMedia,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface NpsErrorAlertProps {
	onRetry: () => void;
}

export function NpsErrorAlert({ onRetry }: NpsErrorAlertProps) {
	return (
		<AlertDialogContent>
			<AlertDialogHeader>
				<AlertDialogMedia>
					<XCircle className="text-destructive" />
				</AlertDialogMedia>
				<AlertDialogTitle>
					Não foi possível enviar sua avaliação
				</AlertDialogTitle>
				<AlertDialogDescription>
					Ocorreu um erro inesperado ao tentar registrar sua avaliação.
					Verifique sua conexão e tente novamente em instantes.
				</AlertDialogDescription>
			</AlertDialogHeader>
			<AlertDialogFooter>
				<AlertDialogCancel>Fechar</AlertDialogCancel>
				<AlertDialogAction onClick={onRetry}>
					Tentar novamente
				</AlertDialogAction>
			</AlertDialogFooter>
		</AlertDialogContent>
	);
}
